module.exports = __webpack_public_path__ + "static/hope-in-the-dark-273f56e83821858373283127dc7665f3.jpg";